import TextInputLoader from 'design-system/src/Components/ContentLoader/TextInputLoader/TextInputLoader';
import React, {ReactNode, Suspense} from 'react';

const UmbracoFormFieldSuspense = ({children}: {children: ReactNode}) => {
  return <Suspense fallback={<TextInputLoader />}>{children}</Suspense>;
};

export default UmbracoFormFieldSuspense;
